// extracted by mini-css-extract-plugin
export default {"drawerTitle":"drawers_drawerTitle__ck6oR"};